import { useSnackbar } from "../product/hooks/SnackbarProvider";

// Keep restricted controls clickable so we can explain why they are unavailable.
// Search controls explicitly opt in to normal mouse and keyboard interaction.
const DisabledNavigation = ({ children, label }) => {
  const showSnackbar = useSnackbar();
  const blockInteraction = (event) => {
    if (event.target.closest?.("[data-kds-navigation-enabled]")) return;
    event.preventDefault();
    event.stopPropagation();
    if (
      event.type === "click" ||
      (event.type === "keydown" && (event.key === "Enter" || event.key === " "))
    ) {
      showSnackbar("These features cannot be accessed in KDS Mode.", "info");
    }
  };

  return (
    <div
      className="navbar-disabled-region"
      aria-disabled="true"
      aria-label={label}
      onClickCapture={blockInteraction}
      onKeyDownCapture={blockInteraction}
      onKeyUpCapture={blockInteraction}
      onSubmitCapture={blockInteraction}
    >
      {children}
    </div>
  );
};

export default DisabledNavigation;
